import { render } from "./AboutUsSectionOneCMS.vue?vue&type=template&id=5e4c1e72"
import script from "../js/about-us-section-one-cms?vue&type=script&lang=js"
export * from "../js/about-us-section-one-cms?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__